import React from 'react/addons';
import ClassNames from 'classnames';
import Tab from 'components/tabs/Tab';
import TabTemplate from 'components/tabs/TabTemplate';
import InkBar from 'components/ink-bar/InkBar';
import StylePropable from 'mixins/js/StylePropable.js';
import Colors from 'mixins/js/colors.js';
import FlatButton from 'components/buttons/flat-button/FlatButton';
import Paper from 'components/paper/Paper';
import Divider from 'components/divider/Divider';
import FontIcon from 'components/font-icon/FontIcon';

export default React.createClass({

	mixins: [StylePropable],

	propTypes: {
		initialSelectedIndex: React.PropTypes.number,
		onActive: React.PropTypes.func,
		tabWidth: React.PropTypes.number,
		dynamicWidth: React.PropTypes.bool,
		tabItemContainerBottom: React.PropTypes.bool,
		height: React.PropTypes.string
	},

	getDefaultProps(){
		return {
			dynamicWidth: true,
			tabItemContainerBottom: false,
			height: "auto"

		};
	},

	getInitialState(){
		let selectedIndex = 0;
		if (this.props.initialSelectedIndex && this.props.initialSelectedIndex < this.props.children.length) {
			selectedIndex = this.props.initialSelectedIndex;
		};
		return {
			selectedIndex: selectedIndex,
			width: null,
			tabs: this.props.children,
			isScrollable: false,
		};
	},

	getEvenWidth(){
		return (
			parseInt(window
				.getComputedStyle(React.findDOMNode(this))
				.getPropertyValue('width'), 10)
		);
	},

	componentDidMount(){
		let _this = this;

		if (!this.props.dynamicWidth) {
			this._validateTabWidth();
		};
		this._setScrollbar();

		setTimeout(() => {
			this._updateInkBar();
		}, 50);

		window.addEventListener('resize', this._setScrollbar);
	},

	componentWillUnmount(){
		window.removeEventListener('resize', this._setScrollbar);
	},

	componentDidUpdate(prevProps, prevState){
		if(prevState.tabs !== this.state.tabs) {
			this._validateTabWidth();
			this._setScrollbar();
			this._updateInkBar();
		};

		if (prevState.selectedIndex !== this.state.selectedIndex){
			this._updateInkBar();
		}
	},

	handleTouchTap(tabIndex, tab){
		if (this.props.onChange && this.state.selectedIndex !== tabIndex) {
			this.props.onChange(tabIndex, tab);
		}

		this.setState({selectedIndex: tabIndex});
		//default CB is _onActive. Can be updated in Tab.js
		if(tab.props.onActive ) tab.props.onActive(tab);
	},

	render(){

		let { tabWidth, dynamicWidth } = this.props,
			width,
			tabItemContainerTop,
			tabItemContainerBottom,
			dividerTop,
			dividerBottom;

		if (!this.props.dynamicWidth) {
			width = this.state.fixed ?
			this.state.width/this.state.tabs.length :
			tabWidth;
		} else {
			width = null;
		};

		let tabItemContainerWrapperClasses = ClassNames('lui-tab-item-container-wrapper',{
			'lui-is-scrollable' : this.state.isScrollable
		});

		let scrollButtonLeftClasses = ClassNames('lui-tabs-container-scroll-button-left', {
			'lui-is-scrollable' : this.state.isScrollable,
			'lui-is-bottom' : this.props.tabItemContainerBottom
		});

		let scrollButtonRightClasses = ClassNames('lui-tabs-container-scroll-button-right', {
			'lui-is-scrollable' : this.state.isScrollable,
			'lui-is-bottom' : this.props.tabItemContainerBottom
		});

		let inkBarClasses = ClassNames ({
			'lui-is-scrollable' : this.state.isScrollable
		});

		let currentTemplate;
		let tabs = React.Children.map(this.props.children, function(tab, index){
			if(tab.type.displayName === "Tab"){
				if(this.state.selectedIndex === index) currentTemplate = tab.props.children;
				 return React.cloneElement(tab, {
						key: index,
						ref: `tab${index}`,
						selected: this.state.selectedIndex === index,
						tabIndex: index,
						width: width,
						handleTouchTap: this.handleTouchTap,
						children: tab.props.children
					})
			} else {
				let type = tab.type.displayName || tab.type;
				throw "Tabs only accepts Tab Components as children. Found " + type + " as child number " + (index + 1) + " of Tabs";
			}
		}, this);

		let tabItemContainer = (
			<div ref="tabItemContainerWrapper" className={tabItemContainerWrapperClasses}>
				<div ref="tabItemContainer" className="lui-tab-item-container">
					{tabs}
					<InkBar ref="inkbar" className={inkBarClasses} />
					<FontIcon onClick={this._handleScrollClick.bind(this , 'left')} className={scrollButtonLeftClasses} icon="chevron-left" />
					<FontIcon onClick={this._handleScrollClick.bind(this , 'right')} className={scrollButtonRightClasses} icon="chevron-right" />
				</div>
			</div>
		);

		let divider = (
			<Divider marginTop={0} marginBottom={0} />
		);

		if (this.props.tabItemContainerBottom) {
			tabItemContainerBottom = tabItemContainer;
			dividerBottom = divider;
			tabItemContainerTop = '';
			dividerTop = '';

		} else {

			tabItemContainerBottom = '';
			dividerBottom = '';
			tabItemContainerTop = tabItemContainer;
			dividerTop = divider;
		};

		let tabTemplateStyles = {
			height: this.props.height
		}

		return (
			<div className="lui-tabs-container">
				<Paper>
					{tabItemContainerTop}
				</Paper>
				{dividerTop}
				<TabTemplate style={tabTemplateStyles} >
					{currentTemplate}
				</TabTemplate>
				{dividerBottom}
				{tabItemContainerBottom}
			</div>
		);
	},

	addTab(label, content, onActive, disabled){
		let tab = (
			<Tab label={label} onActive={onActive} disabled={disabled}>
				{content}
			</Tab>
		);

		let tabArray = this.state.tabs,
			clonedTabArray = tabArray.slice(0),
			selectedIndex;

		clonedTabArray.push(tab);

		if (this.state.selectedIndex < 0) {
			selectedIndex = 0;
		};

		if (this.state.selectedIndex >= 0){
			selectedIndex = this.state.selectedIndex;
		};

		this.setState({
			tabs: clonedTabArray,
			selectedIndex: selectedIndex
		});

	},

	removeTab(position){

		let tabArray = this.state.tabs,
			clonedTabArray = tabArray.slice(0),
			selectedIndex = this.state.selectedIndex;

		clonedTabArray.splice(position, 1);

		if(selectedIndex > clonedTabArray.length -1) {
			selectedIndex = clonedTabArray.length -1;
		};

		if(clonedTabArray.length === 0) {
			selectedIndex = -1;
		};

		this.setState({
			tabs: clonedTabArray,
			selectedIndex: selectedIndex
		});

	},

	_setScrollbar() {

		let container = React.findDOMNode(this.refs.tabItemContainer),
			wrapper = React.findDOMNode(this.refs.tabItemContainerWrapper);

		let _this = this;

		if (container.scrollWidth > wrapper.offsetWidth && !this.state.isScrollable) {

			this.setState({
				isScrollable: true
			});

			setTimeout(() => {
				_this._updateInkBar();
			}, 1);

		} else if (container.scrollWidth <= wrapper.offsetWidth && this.state.isScrollable) {

			this.setState({
				isScrollable: false
			});

			setTimeout(() => {
				_this._updateInkBar();
			}, 1);
		};

	},

	// Validates that the tabWidth can fit all tabs on the tab bar. If not, the
	// tabWidth is recalculated and fixed.
	_validateTabWidth(){
		if(this.props.tabWidth) {
			if(!(this.props.children.length * this.props.tabWidth > this.getEvenWidth())){
				this.setState({
					width: this.props.tabWidth,
					fixed: false
				});
				return;
			};
		};

		this.setState({
			width: this.getEvenWidth(),
			fixed: true
		});
	},

	_handleScrollClick(direction){
		let wrapper = React.findDOMNode(this.refs.tabItemContainerWrapper),
			container = React.findDOMNode(this.refs.tabItemContainer),
			scrollLeft = container.scrollLeft;

		switch (direction) {
			case 'left':
				this._smoothScrollLeft(container, scrollLeft - wrapper.offsetWidth, 600);
				break;
			case 'right':
				this._smoothScrollLeft(container, scrollLeft + wrapper.offsetWidth, 600);
				break;
		};
	},

	_scrollLeft(scrollDuration) {
		let container = React.findDOMNode(this.refs.tabItemContainer),
			scrollLeft = container.scrollLeft,
			scrollStep = Math.PI / ( scrollDuration / 15 ),
			cosParameter = scrollLeft,
			scrollCount = 0,
			scrollMargin;

		requestAnimationFrame(step);

		let _this = this;

		function step () {
			setTimeout(function() {
				if ( container.scrollLeft != 500 ) {
					requestAnimationFrame(step);

					scrollCount = scrollCount + 1;
					scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );

					container.scrollLeft += 20;

					console.log(scrollMargin, container.scrollLeft)
				}
			}, 15 );
		}
	},

	_updateInkBar() {

		let selectedNode,
			selectedNodeWidth,
			selectedNodeLeft;

		if (this.state.selectedIndex >= 0) {

			selectedNode = React.findDOMNode(this.refs[`tab${this.state.selectedIndex}`]);
			selectedNodeWidth = selectedNode.offsetWidth;
			selectedNodeLeft = selectedNode.offsetLeft;

		} else if (this.state.selectedIndex < 0) {

			selectedNodeWidth = 0;
			selectedNodeLeft = 0;
		}

		this.refs.inkbar.setWidth(selectedNodeWidth);
		this.refs.inkbar.setLeft(selectedNodeLeft);
	},

	_smoothScrollLeft (element, target, duration) {

		target = Math.round(target);
		duration = Math.round(duration);

		if (duration < 0) {
			return Promise.reject("bad duration");
		};

		if (duration === 0) {
			element.scrollLeft = target;
			return Promise.resolve();
		};

		let start_time = Date.now();
		let end_time = start_time + duration;

		let start_top = element.scrollLeft;
		let distance = target - start_top;

		// based on http://en.wikipedia.org/wiki/Smoothstep
		let smooth_step = function(start, end, point) {
			if(point <= start) { return 0; }
			if(point >= end) { return 1; }
			let x = (point - start) / (end - start); // interpolation
			return x*x*x*(x*(x*6 - 15) + 10);
		}

		return new Promise(function(resolve, reject) {
			// This is to keep track of where the element's scrollLeft is
			// supposed to be, based on what we're doing
			let previous_top = element.scrollLeft;

			// This is like a think function from a game loop
			let scroll_frame = function() {
				if(element.scrollLeft != previous_top) {
					reject("interrupted");
					return;
				}

				// set the scrollLeft for this frame
				let now = Date.now();
				let point = smooth_step(start_time, end_time, now);
				let frameTop = Math.round(start_top + (distance * point));
				element.scrollLeft = frameTop;

				// check if we're done!
				if(now >= end_time) {
					resolve();
					return;
				}

				// If we were supposed to scroll but didn't, then we
				// probably hit the limit, so consider it done; not
				// interrupted.
				if(element.scrollLeft === previous_top
					&& element.scrollLeft !== frameTop) {
					resolve();
					return;
				}
				previous_top = element.scrollLeft;

				// schedule next frame for execution
				setTimeout(scroll_frame, 0);
			}

			// boostrap the animation process
			setTimeout(scroll_frame, 0);
		});
	},
});



/** WEBPACK FOOTER **
 ** ./src/components/tabs/Tabs.js
 **/